import { useQuery } from '@tanstack/react-query';
import { getQCImpactOptions, getQCLabelOptions } from 'api/qcMarkers';

export const qcLabelsQueryKey = ['qcLabels'];

export const useQCLabels = () => {
  return useQuery({
    queryKey: qcLabelsQueryKey,
    queryFn: getQCLabelOptions,
  });
};

export const qcImpactsQueryKey = ['qcImpacts'];

export const useQCImpacts = () => {
  return useQuery({
    queryKey: qcImpactsQueryKey,
    queryFn: getQCImpactOptions,
  });
};
